import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Car, Plane, RotateCcw, User } from 'lucide-react';

const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: <Car className="w-8 h-8" />,
      title: t.services.tours.title,
      description: t.services.tours.description,
    },
    {
      icon: <Plane className="w-8 h-8" />,
      title: t.services.transfers.title,
      description: t.services.transfers.description,
    },
    {
      icon: <RotateCcw className="w-8 h-8" />,
      title: t.services.roundtrip.title,
      description: t.services.roundtrip.description,
    },
    {
      icon: <User className="w-8 h-8" />,
      title: t.services.private.title,
      description: t.services.private.description,
    },
  ];

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4">
            {t.services.title}
          </h2>
          <p className="text-stone-600 max-w-2xl mx-auto text-lg">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-stone-100 hover:border-teal-200"
            >
              <div className="w-16 h-16 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center mb-6 group-hover:bg-teal-600 group-hover:text-white transition-colors duration-300">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold text-stone-800 mb-3">
                {service.title}
              </h3>
              <p className="text-stone-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;